import {wordSlider} from "./word-slider.js";

export const heroGeneral = ()=> {
    wordSlider();
}